import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "panelAI"
};
const _hoisted_2 = {
  class: "cardContainer"
};
const _hoisted_3 = {
  class: "labelConsumptionAiCreditsTitle"
};
const _hoisted_4 = {
  class: "usage"
};
const _hoisted_5 = {
  class: "usageConsume"
};
const _hoisted_6 = {
  class: "usageLimit"
};
const _hoisted_7 = {
  class: "buttonLineBox"
};
const _hoisted_8 = {
  class: "confirmTitle"
};
const _hoisted_9 = {
  class: "messagePurchase"
};
const _hoisted_10 = {
  class: "messageSpan"
};
const _hoisted_11 = {
  class: "disclaimerPurchase"
};
const _hoisted_12 = {
  class: "confirmButtonBar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_progress = _resolveComponent("el-progress");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_light_button = _resolveComponent("light-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiPanel.limitAICredits')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.usageFormatted), 1), _createElementVNode("span", _hoisted_6, " / " + _toDisplayString(_ctx.realLimit), 1), _createVNode(_component_el_progress, {
    class: "progressBar",
    percentage: _ctx.pourcentageUsage,
    "show-text": false
  }, null, 8, ["percentage"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _cache[0] || (_cache[0] = $event => {
      _ctx.showConfirm = true;
    })
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiPanel.addTime')), 1)]),
    _: 1
  })])]), _createVNode(_component_w_dialog, {
    visible: _ctx.showConfirm,
    onOnDialogClose: _cache[2] || (_cache[2] = $event => _ctx.showConfirm = false)
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('aiPanel.confirm.title')), 1)]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_light_button, {
      class: "buttonCancelAICredits",
      onAction: _cache[1] || (_cache[1] = $event => _ctx.showConfirm = false)
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiPanel.confirm.cancel')), 1)]),
      _: 1
    }), _createVNode(_component_standard_button, {
      onAction: _ctx.buyCredits
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiPanel.confirm.ok')), 1)]),
      _: 1
    }, 8, ["onAction"])])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_cache[3] || (_cache[3] = _createElementVNode("span", {
      class: "imageElement"
    }, null, -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('aiPanel.confirm.message')), 1)]), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('aiPanel.confirm.disclaimer')), 1)]),
    _: 1
  }, 8, ["visible"])]);
}